import { render, staticRenderFns } from "./templateSelect.vue?vue&type=template&id=2e37155f&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./templateSelect.vue?vue&type=style&index=0&id=2e37155f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e37155f",
  null
  
)

export default component.exports